import { 
  Users,
  Scale,
  PiggyBank,
  GraduationCap
} from 'lucide-react';

export const verktygsTranslations = {
  sv: {
    pageTitle: 'Skogskalkylatorer',
    pageSubtitle: 'För dig som äger skog i Sverige – oavsett om du bor på fastigheten, i staden eller utomlands. Räkna ut volym, värde, avverkning och fastighetsvärde med oberoende underlag.',
    seoIntro: 'Skogskalkyl är ett digitalt verktyg för skogsägare på distans som vill göra oberoende beräkningar för sin svenska skog. Här finns praktiska kalkylatorer för virkesvolym, ekonomi och skogsplanering.',
    backToAll: '← Tillbaka till alla kalkylatorer',
    aboutTitle: 'Om våra skogskalkylatorer',
    aboutText1: 'Våra skogsbruk verktyg är utvecklade för svenska förhållanden och använder data från Skogsstyrelsen och SLU Riksskogstaxeringen.',
    aboutText2: 'Behöver du göra en skog värde beräkning? Använd vår virkesvärde-kalkylator med aktuella virkespris.',
    aboutText3: 'Testa kalkylatorerna fritt.',
    loginRequired: '',
    loginText: '',
    guestModeTitle: '',
    guestModeText: 'Du kan räkna direkt – ingen registrering krävs.',
    createAccount: '',
    login: '',
    filterLabel: 'Jag är...',
    filterAll: 'Visa alla',
    filterOwner: 'Skogsägare',
    filterBroker: 'Mäklare',
    filterInvestor: 'Investerare',
    filterStudent: 'Student',
    recommended: 'Rekommenderat',
    premiumBadge: '',
    sectionRecommended: 'Rekommenderat för dig',
    sectionOthers: 'Övriga kalkylatorer',
    defaultsNote: 'Standardvärden kan ändras. Baserat på officiell statistik.',
    categories: {
      virke: { title: 'Virke & Volym', description: 'Beräkningar för virkesvolym och värde' },
      planering: { title: 'Skogsplanering', description: 'Verktyg för planering av skogsskötsel' },
      ekonomi: { title: 'Ekonomi', description: 'Ekonomiska beräkningar och investeringar' },
      klimat: { title: 'Klimat & Biomassa', description: 'Kolbindning och miljöberäkningar' },
      maklare: { title: 'Fastighet & Värdering', description: 'Verktyg för fastighetsvärdering' },
      avancerat: { title: 'Avancerat', description: 'Avancerade verktyg och scenariojämförelse' }
    },
    calculators: {
      virkesvolym: { name: 'Virkesvolym', description: 'Beräkna kubikinnehåll baserat på diameter, höjd och antal träd' },
      virkesvarde: { name: 'Virkesvärde', description: 'Uppskatta värdet på ditt virke med aktuella priser' },
      avverkning: { name: 'Avverkningsintäkt', description: 'Beräkna nettointäkt från slutavverkning eller gallring' },
      plantering: { name: 'Planteringskostnad', description: 'Beräkna kostnaden för återbeskogning' },
      rojning: { name: 'Röjningskostnad', description: 'Uppskatta kostnaden för röjning av ungskog' },
      gallring: { name: 'Gallring', description: 'Beräkna uttag och intäkt vid gallring' },
      tillvaxt: { name: 'Skogstillväxt', description: 'Uppskatta framtida virkesvolym' },
      markvarde: { name: 'Markvärde', description: 'Uppskatta värdet på skogsmark' },
      projekt: { name: 'Projektkostnad', description: 'Budgetera ett komplett skogsprojekt' },
      co2: { name: 'CO₂ kalkylator', description: 'Beräkna kollagring och koldioxidbindning' },
      fastighetsvarde: { name: 'Fastighetsvärde', description: 'Uppskatta värdet på en skogsfastighet' },
      prisPerHektar: { name: 'Pris per hektar', description: 'Beräkna pris per hektar och m³sk' },
      markVirke: { name: 'Mark vs Virkesvärde', description: 'Analysera fördelningen mellan mark- och virkesvärde' },
      provision: { name: 'Mäklarprovision', description: 'Beräkna provision vid fastighetsförsäljning' },
      avancerad: { name: 'Avancerad skogskalkyl', description: 'Komplett ekonomisk analys med riskscenarier och långsiktig planering' },
      jamfor: { name: 'Jämför scenarier', description: 'Jämför två skogsscenarier sida vid sida' }
    }
  },
  de: {
    pageTitle: 'Waldkalkulatoren',
    pageSubtitle: 'Für Sie als Eigentümer von Wald in Schweden – ob Sie auf dem Grundstück, in der Stadt oder im Ausland leben. Berechnen Sie Volumen, Wert, Holzeinschlag und Immobilienwert mit unabhängiger Datengrundlage.',
    seoIntro: 'Waldrechner ist ein digitales Werkzeug für Waldbesitzer auf Distanz, die unabhängige Berechnungen für ihren schwedischen Wald durchführen möchten.',
    backToAll: '← Zurück zu allen Kalkulatoren',
    aboutTitle: 'Über unsere Waldkalkulatoren',
    aboutText1: 'Unsere Forstwirtschaft-Werkzeuge basieren auf offiziellen Forststatistiken.',
    aboutText2: 'Möchten Sie den Waldwert berechnen? Nutzen Sie unseren Holzwert-Rechner mit aktuellen Preisen.',
    aboutText3: 'Rechner frei testen.',
    loginRequired: '',
    loginText: '',
    guestModeTitle: '',
    guestModeText: 'Sie können direkt rechnen – keine Registrierung erforderlich.',
    createAccount: '',
    login: '',
    filterLabel: 'Ich bin...',
    filterOwner: 'Waldbesitzer',
    filterBroker: 'Makler',
    filterInvestor: 'Investor',
    filterStudent: 'Student',
    filterAll: 'Alle anzeigen',
    recommended: 'Empfohlen',
    premiumBadge: '',
    sectionRecommended: 'Empfohlen für dich',
    sectionOthers: 'Weitere Kalkulatoren',
    defaultsNote: 'Standardwerte können geändert werden.',
    categories: {
      virke: { title: 'Holz & Volumen', description: 'Berechnungen für Holzvolumen und Wert' },
      planering: { title: 'Waldplanung', description: 'Werkzeuge für Waldbewirtschaftung' },
      ekonomi: { title: 'Wirtschaft', description: 'Wirtschaftliche Berechnungen und Investitionen' },
      klimat: { title: 'Klima & Biomasse', description: 'Kohlenstoffbindung und Umweltberechnungen' },
      maklare: { title: 'Immobilie & Bewertung', description: 'Werkzeuge für Immobilienbewertung' },
      avancerat: { title: 'Erweitert', description: 'Erweiterte Werkzeuge und Szenariovergleich' }
    },
    calculators: {
      virkesvolym: { name: 'Holzvolumen', description: 'Berechnen Sie das Kubikvolumen' },
      virkesvarde: { name: 'Holzwert', description: 'Schätzen Sie den Wert Ihres Holzes' },
      avverkning: { name: 'Ernteertrag', description: 'Berechnen Sie den Nettoertrag' },
      plantering: { name: 'Aufforstungskosten', description: 'Berechnen Sie die Kosten für Aufforstung' },
      rojning: { name: 'Läuterungskosten', description: 'Schätzen Sie die Kosten für Jungbestandspflege' },
      gallring: { name: 'Durchforstung', description: 'Berechnen Sie Entnahme und Ertrag' },
      tillvaxt: { name: 'Waldzuwachs', description: 'Schätzen Sie das zukünftige Holzvolumen' },
      markvarde: { name: 'Bodenwert', description: 'Schätzen Sie den Wert von Waldboden' },
      projekt: { name: 'Projektkosten', description: 'Budgetieren Sie ein Waldprojekt' },
      co2: { name: 'CO₂ Rechner', description: 'Berechnen Sie Kohlenstoffspeicherung' },
      fastighetsvarde: { name: 'Immobilienwert', description: 'Schätzen Sie den Wert einer Waldimmobilie' },
      prisPerHektar: { name: 'Preis pro Hektar', description: 'Berechnen Sie den Preis pro Hektar' },
      markVirke: { name: 'Boden vs Holzwert', description: 'Analysieren Sie die Wertverteilung' },
      provision: { name: 'Maklerprovision', description: 'Berechnen Sie die Provision' },
      avancerad: { name: 'Erweiterter Waldrechner', description: 'Vollständige wirtschaftliche Analyse mit Risikoszenarien' },
      jamfor: { name: 'Szenarien vergleichen', description: 'Vergleichen Sie zwei Waldszenarien nebeneinander' }
    }
  },
  en: {
    pageTitle: 'Forest Calculators',
    pageSubtitle: 'For you as an owner of forest in Sweden – whether you live on the property, in the city, or abroad. Calculate volume, value, harvest and property value with independent data.',
    seoIntro: 'Forest Calculator is a digital tool for remote forest owners who want to make independent calculations for their Swedish forest.',
    backToAll: '← Back to all calculators',
    aboutTitle: 'About our forest calculators',
    aboutText1: 'Our forestry tools are developed based on official forest statistics.',
    aboutText2: 'Need to calculate forest value? Use our timber value calculator with current prices.',
    aboutText3: 'Try the calculators freely.',
    loginRequired: '',
    loginText: '',
    guestModeTitle: '',
    guestModeText: 'You can calculate directly – no registration required.',
    createAccount: '',
    login: '',
    filterLabel: 'I am a...',
    filterAll: 'Show all',
    filterOwner: 'Forest owner',
    filterBroker: 'Broker',
    filterInvestor: 'Investor',
    filterStudent: 'Student',
    recommended: 'Recommended',
    premiumBadge: '',
    sectionRecommended: 'Recommended for you',
    sectionOthers: 'Other calculators',
    defaultsNote: 'Default values can be modified.',
    categories: {
      virke: { title: 'Timber & Volume', description: 'Calculations for timber volume and value' },
      planering: { title: 'Forest Planning', description: 'Tools for forest management planning' },
      ekonomi: { title: 'Economics', description: 'Economic calculations and investments' },
      klimat: { title: 'Climate & Biomass', description: 'Carbon sequestration and environmental calculations' },
      maklare: { title: 'Property & Valuation', description: 'Tools for property valuation' },
      avancerat: { title: 'Advanced', description: 'Advanced tools and scenario comparison' }
    },
    calculators: {
      virkesvolym: { name: 'Timber Volume', description: 'Calculate cubic content' },
      virkesvarde: { name: 'Timber Value', description: 'Estimate the value of your timber' },
      avverkning: { name: 'Harvest Revenue', description: 'Calculate net income from harvest' },
      plantering: { name: 'Planting Cost', description: 'Calculate the cost of reforestation' },
      rojning: { name: 'Clearing Cost', description: 'Estimate the cost of pre-commercial thinning' },
      gallring: { name: 'Thinning', description: 'Calculate removal and income from thinning' },
      tillvaxt: { name: 'Forest Growth', description: 'Estimate future timber volume' },
      markvarde: { name: 'Land Value', description: 'Estimate the value of forest land' },
      projekt: { name: 'Project Cost', description: 'Budget a complete forest project' },
      co2: { name: 'CO₂ Calculator', description: 'Calculate carbon storage' },
      fastighetsvarde: { name: 'Property Value', description: 'Estimate forest property value' },
      prisPerHektar: { name: 'Price per hectare', description: 'Calculate price per hectare' },
      markVirke: { name: 'Land vs Timber', description: 'Analyze value distribution' },
      provision: { name: 'Broker Commission', description: 'Calculate commission' },
      avancerad: { name: 'Advanced Forest Calculator', description: 'Complete economic analysis with risk scenarios' },
      jamfor: { name: 'Compare Scenarios', description: 'Compare two forest scenarios side-by-side' }
    }
  },
  se: {
    pageTitle: 'Meahccerehkenastit',
    pageSubtitle: 'Geavatlaš reaiddut meahcceeaiggádiidda.',
    seoIntro: 'Meahccerehkenastin lea digitála reaidu meahcceeaiggádiidda.',
    backToAll: '← Ruovttoluotta buot rehkenastimiidda',
    aboutTitle: 'Min meahccerehkenastimiin birra',
    aboutText1: 'Min meahccereaiddut leat ráhkaduvvon virggálaš statistihka vuođul.',
    aboutText2: 'Dárbbašat go rehkenastit meahcceárvvu?',
    aboutText3: 'Buot rehkenastit leat nuvttá.',
    loginRequired: '',
    loginText: '',
    createAccount: '',
    login: '',
    filterLabel: 'Mun lean...',
    filterAll: 'Čájet buot',
    filterOwner: 'Meahcceeaiggát',
    filterBroker: 'Máklár',
    filterInvestor: 'Investor',
    filterStudent: 'Studeanta',
    recommended: 'Ávžžuhuvvon',
    premiumBadge: '',
    sectionRecommended: 'Ávžžuhuvvon dutnje',
    sectionOthers: 'Eará rehkenastimat',
    defaultsNote: 'Standárdaárvvut sáhttet rievdaduvvot.',
    categories: {
      virke: { title: 'Muorra & Voluma', description: 'Rehkenastimat muorravolumii' },
      planering: { title: 'Meahcceplánen', description: 'Reaiddut meahccedikšuma plánenmii' },
      ekonomi: { title: 'Ekonomiija', description: 'Ekonomalaš rehkenastimat' },
      klimat: { title: 'Dálkkádat & Biomássa', description: 'Čáđaheapmi ja birasrehkenastimat' },
      maklare: { title: 'Opmodat & Árvvoštallami', description: 'Reaiddut opmodatárvvoštallami' },
      avancerat: { title: 'Ovddidumos', description: 'Ovddidumos reaiddut' }
    },
    calculators: {
      virkesvolym: { name: 'Muorravoluma', description: 'Rehkenas kubihkasisdoalu' },
      virkesvarde: { name: 'Muorraárvu', description: 'Árvvoš muora árvvu' },
      avverkning: { name: 'Čuohppanboađut', description: 'Rehkenas neahttaboađuid' },
      plantering: { name: 'Gilvengolatvuohta', description: 'Rehkenas gilvema goluid' },
      rojning: { name: 'Čorgengolatvuohta', description: 'Árvvoš čorgema goluid' },
      gallring: { name: 'Čierastus', description: 'Rehkenas váldinvoluma' },
      tillvaxt: { name: 'Meahccelassáneapmi', description: 'Árvvoš boahttevaš voluma' },
      markvarde: { name: 'Eatnanárvu', description: 'Árvvoš meahcceeana árvvu' },
      projekt: { name: 'Prošeaktabargu', description: 'Bušeahte prošeavtta' },
      co2: { name: 'CO₂ rehkenastin', description: 'Rehkenas čáđačoaggimiid' },
      fastighetsvarde: { name: 'Opmodatárvu', description: 'Árvvoš opmodaga árvvu' },
      prisPerHektar: { name: 'Haddi hektáras', description: 'Rehkenas haddi' },
      markVirke: { name: 'Eanan vs Muorra', description: 'Analyser juogadeami' },
      provision: { name: 'Meklárprovišuvdna', description: 'Rehkenas provišuvnna' },
      avancerad: { name: 'Ovddidumos meahccerehkenastin', description: 'Ollislaš analysa riskaskenáriojiin' },
      jamfor: { name: 'Buohtastahte skenáriojaid', description: 'Buohtastahte guokte skenário' }
    }
  }
};

// Onboarding translations
export const onboardingTranslations = {
  sv: {
    title: 'Kom igång med Skogskalkyl',
    step1Title: '1. Välj din roll',
    step1Text: 'Välj vad som bäst beskriver dig så visar vi rekommenderade kalkylatorer.',
    step2Title: '2. Rekommenderade verktyg',
    step2Text: 'Baserat på din roll rekommenderar vi dessa kalkylatorer:',
    step3Title: '3. Börja beräkna',
    step3Text: 'Utforska kalkylatorerna och prova att göra din första beräkning!',
    next: 'Nästa',
    finish: 'Börja använda',
    skip: 'Hoppa över',
    userTypes: {
      owner: { name: 'Skogsägare', tools: ['Virkesvolym', 'Virkesvärde', 'Skogstillväxt'] },
      broker: { name: 'Skogsmäklare', tools: ['Fastighetsvärde', 'Pris per hektar', 'Provision'] },
      investor: { name: 'Investerare', tools: ['Skogsvärde', 'Tillväxt', 'CO₂'] },
      student: { name: 'Student', tools: ['Virkesvolym', 'CO₂', 'Tillväxt'] }
    }
  },
  de: {
    title: 'Erste Schritte mit Skogskalkyl',
    step1Title: '1. Wählen Sie Ihre Rolle',
    step1Text: 'Wählen Sie, was Sie am besten beschreibt, um empfohlene Rechner anzuzeigen.',
    step2Title: '2. Empfohlene Werkzeuge',
    step2Text: 'Basierend auf Ihrer Rolle empfehlen wir diese Kalkulatoren:',
    step3Title: '3. Beginnen Sie zu rechnen',
    step3Text: 'Erkunden Sie die Kalkulatoren und machen Sie Ihre erste Berechnung!',
    next: 'Weiter',
    finish: 'Loslegen',
    skip: 'Überspringen',
    userTypes: {
      owner: { name: 'Waldbesitzer', tools: ['Holzvolumen', 'Holzwert', 'Waldzuwachs'] },
      broker: { name: 'Waldmakler', tools: ['Immobilienwert', 'Preis pro Hektar', 'Provision'] },
      investor: { name: 'Investor', tools: ['Waldwert', 'Zuwachs', 'CO₂'] },
      student: { name: 'Student', tools: ['Holzvolumen', 'CO₂', 'Zuwachs'] }
    }
  },
  en: {
    title: 'Getting started with Skogskalkyl',
    step1Title: '1. Choose your role',
    step1Text: 'Select what best describes you to show recommended calculators.',
    step2Title: '2. Recommended tools',
    step2Text: 'Based on your role, we recommend these calculators:',
    step3Title: '3. Start calculating',
    step3Text: 'Explore the calculators and make your first calculation!',
    next: 'Next',
    finish: 'Get started',
    skip: 'Skip',
    userTypes: {
      owner: { name: 'Forest Owner', tools: ['Timber Volume', 'Timber Value', 'Forest Growth'] },
      broker: { name: 'Forest Broker', tools: ['Property Value', 'Price per Hectare', 'Commission'] },
      investor: { name: 'Investor', tools: ['Forest Value', 'Growth', 'CO₂'] },
      student: { name: 'Student', tools: ['Timber Volume', 'CO₂', 'Growth'] }
    }
  },
  se: {
    title: 'Álggat Skogskalkyliin',
    step1Title: '1. Vállje rolla',
    step1Text: 'Vállje mii buoremusat govvida du.',
    step2Title: '2. Ávžžuhuvvon reaiddut',
    step2Text: 'Du rolla vuođul ávžžuhit dáid rehkenastimiid:',
    step3Title: '3. Álggat rehkenastit',
    step3Text: 'Guorahala rehkenastimiid ja daga vuosttaš rehkenastima!',
    next: 'Čuovvovaš',
    finish: 'Álggat',
    skip: 'Skirre',
    userTypes: {
      owner: { name: 'Meahcceeaiggát', tools: ['Muorravoluma', 'Muorraárvu', 'Lassáneapmi'] },
      broker: { name: 'Máklár', tools: ['Opmodatárvu', 'Haddi', 'Provišuvdna'] },
      investor: { name: 'Investor', tools: ['Meahcceárvu', 'Lassáneapmi', 'CO₂'] },
      student: { name: 'Studeanta', tools: ['Muorravoluma', 'CO₂', 'Lassáneapmi'] }
    }
  }
};

// User type icons mapping
export const userTypeIcons = {
  owner: Users,
  broker: Scale,
  investor: PiggyBank,
  student: GraduationCap
};

// User type recommendations for calculators.
// IMPORTANT: order matters – first entries are rendered first.
// Premium-paid calculators (Beslutsläge 149 kr) come first because they
// represent decision-making value for that user type.
export const userTypeRecommendations = {
  owner:    ['avverkning', 'gallring', 'virkesvolym', 'virkesvarde', 'tillvaxt', 'plantering', 'rojning', 'co2'],
  broker:   ['fastighetsvarde', 'prisPerHektar', 'markVirke', 'provision', 'virkesvarde', 'markvarde'],
  investor: ['fastighetsvarde', 'markvarde', 'prisPerHektar', 'tillvaxt', 'projekt', 'co2'],
  student:  ['virkesvolym', 'virkesvarde', 'tillvaxt', 'plantering', 'gallring', 'co2']
};

// Premium (paid) calculator ids – used to sort them first and badge them.
export const PREMIUM_CALCULATOR_IDS = ['fastighetsvarde', 'avverkning', 'gallring'];
